<template>
    <div class="air_ListBox">
        <div class="search-form">
            <el-row type="flex" :gutter="20" align="middle">
                <el-col class="el-col-label" :span="8">
                    <span>PNR:</span>
                    <input
                        clearable
                        v-model="searchForm.pnr"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                <el-col class="el-col-label" :span="8">
                    <span>订单号:</span>
                    <input
                        clearable
                        v-model="searchForm.orderNo"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                <el-col class="el-col-label" :span="8">
                    <span>票号:</span>
                    <input
                        clearable
                        v-model="searchForm.ticketNumber"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" align="middle" style="margin-top:10px;">
                <el-col class="el-col-label" :span="8">
                    <span>航司:</span>
                    <el-select
                        clearable
                        placeholder=""
                        v-model="searchForm.airlineCode"
                        @change="searchClear"
                    >
                        <el-option
                            v-for="item in airlinesList"
                            :key="item.id"
                            :label="item.airCompanyName"
                            :value="item.airlineCode"
                        ></el-option>
                    </el-select>
                </el-col>
                <el-col class="el-col-label" :span="8">
                    <span>乘客姓名:</span>
                    <input
                        clearable
                        v-model="searchForm.psgName"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                <el-col class="el-col-label" :span="8">
                    <span>下单日期:</span>
                    <el-date-picker
                        v-model="searchForm.orderTimeStart"
                        type="date"
                        class="time_box"
                        :picker-options='selectPickerOptions()'
                        value-format="yyyy-MM-dd"
                        @change="search"
                    ></el-date-picker>
                </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" align="middle" style="margin-top:10px;">
                <el-col :span="8" class="el-col-label">
                    <span>航班号:</span>
                    <input
                        clearable
                        v-model="searchForm.flightNo"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                <el-col :span="8" class="el-col-label">
                    <span>联系电话:</span>
                    <input
                        clearable
                        v-model="searchForm.contactTel"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                <el-col :span="8" class="el-col-label">
                    <span>证件号:</span>
                    <input
                        clearable
                        v-model="searchForm.cardNo"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
            </el-row>
            <div class="btn_box">
                <el-button type="primary" @click="search" size="small">搜索</el-button>
                <el-button  @click="reset" size="small">重置</el-button>
            </div>
        </div>
        <el-row>
            <el-col :span="24">
                <div class="table-nav flex-center">
          <div class="nav-item cursor"
               v-for="(item,index) in changeRecordList"
               :key="index"
               :class="{'nav-item-active':NavItemActive==index}"
               @click="statuSearch(item,index)">
               {{item.text}}
          </div>
                </div>

        <el-table :data="pageData" v-loading="loading" style="width: 100%">
          <el-table-column label="订单号/PNR" width="200" class-name="fz12">
            <template slot-scope="scope">
              <div>
                <p></p>
                <p>{{scope.row.orderNo}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="航班号/行程" width="180" class-name="fz12">
            <template slot-scope="scope">
              <div
                v-for="(segmentEntity,segmentEntityIndex) in scope.row.segmentResults"
                :key="segmentEntityIndex"
              >
                <p>
                  {{segmentEntity.sCityName}}({{segmentEntity.sAirportCode}})-{{segmentEntity.eCityName}}({{segmentEntity.eAirportCode}})</p>
                <p>{{segmentEntity.flightInfo}}</p>

              </div>
            </template>
          </el-table-column>
          <el-table-column label="乘机人" width="100" class-name="fz12">
            <template slot-scope="scope">
              <div
                v-for="(passengerEntity,passengerEntityIndex) in scope.row.passengerList"
                :key="passengerEntityIndex"
              >{{parseInt(passengerEntityIndex) + 1}}.{{passengerEntity}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="航班日期" width="130" class-name="fz12">
            <template slot-scope="scope">
              <div
                v-for="(segmentEntity,segmentEntityIndex) in scope.row.segmentResults"
                :key="segmentEntityIndex"
              >{{segmentEntity.departureDate}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="下单时间" width="150" class-name="fz12">
            <template slot-scope="scope">{{scope.row.orderTime}}</template>
          </el-table-column>
          <el-table-column label="总金额" class-name="fz12">
            <template slot-scope="scope"> <span class="font-10">￥</span>{{scope.row.amount.toFixed(2)}}</template>
          </el-table-column>
          <el-table-column label="状态" width="80" class-name="fz12">
            <template slot-scope="scope">
              {{scope.row.orderStatus==11?'待支付':
              scope.row.orderStatus==12?'已支付':
              scope.row.orderStatus==21?'待出票':
              scope.row.orderStatus==22?'出票成功':
              scope.row.orderStatus==23?'出票失败':
              scope.row.orderStatus==31?'改签处理中':
              scope.row.orderStatus==32?'改签需补款':
              scope.row.orderStatus==33?'改签已补款':
              scope.row.orderStatus==34?'改签成功':
              scope.row.orderStatus==35?'改签失败':
              scope.row.orderStatus==41?'退票处理中':
              scope.row.orderStatus==42?'退票成功':
              scope.row.orderStatus==43?'退票失败':
              scope.row.orderStatus==51?'退款处理中':
              scope.row.orderStatus==52?'退款成功':
              scope.row.orderStatus==53?'退款失败':
              scope.row.orderStatus==90?'已取消':
              ''}}</template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" class-name="fz12">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-show="scope.row.orderStatus==11"
                size="mini"
                @click="setOrdersNo(scope.row,'pay')"
              >支付
              </el-button>
              <el-button
                type="text"
                size="mini"
                @click="setOrdersNo(scope.row,'airDetails')"
              >查看订单
              </el-button>
                <el-button
                  type="text"
                  size="mini"
                  v-show="scope.row.orderStatus==22"
                  @click="setOrdersNo(scope.row,'Changing')"
                >改签申请
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  v-show="scope.row.orderStatus==22"
                  @click="setOrdersNo(scope.row,'Dishonour')"
                >退票申请
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  v-show="scope.row.orderStatus==22"
                  @click="setOrdersNo(scope.row,'changPay')"
                >废票申请
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  v-show="scope.row.orderStatus==11"
                  @click="setOrdersNo(scope.row,'cancel')"
                >取消订单
                </el-button>
                 <!-- <el-button
                  type="text"
                  size="mini"
                  @click="setOrdersNo(scope.row.orderNo,'changPay')"
                >行程单申请
                </el-button> -->
            </template>
          </el-table-column>
         </el-table>
                <div style="margin-bottom: 10px;"></div>
                <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                background
                @size-change="handlerSize"
                @current-change="handlerPage"
                :current-page="searchForm.currentPage"
                :page-sizes="[10,20,30,40,50]"
                :page-size="10"
                :page-count="searchForm.pageSize"
                :total="totalCount"
                ></el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import scrollTop from '@/lib/common-service/scrollTop'
import fligthInternationalList from '@/lib/data-service/flight/fligthInternationalAdmin/flight_international_buyer_manage_order_list.js'
import {internationalAirLines} from '@/lib/data-service/flight/fligthInternational'
import cancel from '@/lib/data-service/flight/fligthInternationalAdmin/flight_international_buyer_white_order_cancel'
import { resolve } from 'q';
export default {
  data() {
    return {
      searchForm: {
        currentPage:1,
        pageSize:10
      },
      totalCount:0,
      changeRecordList:[
        {text:'全部',value:''},
        {text:'待支付',value:11},
        {text:'待出票',value:21},
        {text:'出票成功',value:22},
        {text:'出票失败',value:23},
        {text:'已取消',value:90}
      ],
      NavItemActive:'',
      pageData:[],
      loading:false,
      airlinesList:[
        {
          airlineCode: '',
          airCompanyName: '不限',
          airCompanyEnglistName:'',
          airCompanyShortName:'',
          airlineCode:'',
          countryState:''
        }
      ]
    };
  },
  created(){
    this.search()
    this.getAirlines()
  },
  methods: {
    statuSearch(item,index){
       this.NavItemActive = index
       this.searchForm.orderStatus = item.value
       this.search()
    },
    searchClear() {

    },
    // 日期选择
    selectPickerOptions() {
      return {
        disabledDate: time => {
            return time.getTime() > Date.now()
        }
      }
    },
     // 获取航司列表
    getAirlines() {
      internationalAirLines().then(data => {
        // console.log(data)
        let airlinesList = [...this.airlinesList,...data.pageResult.pageData]
        this.airlinesList = airlinesList
      })
    },
    reset() {
      this.searchForm = {currentPage:1,pageSize:10}
    },
    search(pageNum) {
      let data = this.searchForm
      if(typeof pageNum == 'number'){
          data.currentPage = pageNum||1
      }else{
        data.currentPage = 1
      }
      data.orderTimeStart?data.orderTimeEnd = this.$moment().format('YYYY-MM-DD'):data.orderTimeEnd = ''
      fligthInternationalList(data).then(res=>{
        this.pageData = res.pageResult.pageData
        this.totalCount = res.pageResult.totalCount
        scrollTop(500)
      })
    },
    setOrdersNo(item,type){
      if(type==='pay'){
        this.$router.push({name:'international-pay',query:{ordersNo:item.orderNo,type:'international'},params:{refresh:1}})
      }else if(type==='cancel'){
        this._cancelOrder(item)
      }else{
         this.$router.push({name:'air-ticket-admin-international-list-detail',query:{ordersNo:item.orderNo,type:type,supplierType:item.supplierType}
         ,params:{refresh:1}})
      }
    },
    _cancelOrder(val){
      let data = {
        "orderId": val.orderNo,
        "pnr": ""
      }
       this._setPopPu('确定要取消订单吗？',()=>{
            cancel(data).then(res=>{
              if(res.isSuccess){
                 this.$message({type:"warning",message:"取消订单成功！"})
                 this.search()
              }
            })
        })
    },
    _setPopPu(text,callBack){
        const content = {
            text:text||''
        }
        this.$confirm(content.text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                  return  callBack()
              }).catch(() => {})
    },
    handlerSize(val){
      this.searchForm.pageSize = val
      this.search()
    },
    handlerPage(val){
      this.search(val)
    }
  }
};
</script>

<style lang='less' scoped>
@import "./css/common";
</style>
